import React, { useState } from 'react';

function EyeIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M10.6 5.2A11.6 11.6 0 0 1 12 5c7 0 11 7 11 7a14.6 14.6 0 0 1-3.4 4.1M6.6 6.6C3.4 8.6 1 12 1 12s4 7 11 7a10.7 10.7 0 0 0 4.4-.9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 9.6a3.2 3.2 0 0 0 4.4 4.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Style applied to the wrapping element — use for layout concerns (width, flex) that
   *  need to live on the container rather than the input itself. */
  containerStyle?: React.CSSProperties;
}

export default function PasswordInput({ style, containerStyle, ...rest }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: 'relative', ...containerStyle }}>
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        style={{ ...style, width: '100%', boxSizing: 'border-box', paddingRight: '2.4rem' }}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        tabIndex={-1}
        style={{
          position: 'absolute', right: '0.55rem', top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', padding: '0.25rem', margin: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--chalk-dim)', cursor: 'pointer', lineHeight: 0,
        }}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
}
